import React from "react";
import { Modal, ModalOverflow, ModalDialog, Stack, Button, Typography } from "@financeable-com-au/financeable-ui";

const modalWidth = "480px";

const ConfirmModal = ({
  isOpen,
  title,
  message,
  children,
  setIsOpen,
  handle,
  btnTextYes,
  btnTextNo,
  confirmLoadingText = "Saving...",
  isConfirmLoading = false,
  additionalDetails, // will be html content
}) => {
  const closeDialog = () => {
    handle({ ...isOpen?.roleInfo, isSave: false });
    setIsOpen(false);
  };
  const confirmation = () => {
    handle({ ...isOpen?.roleInfo, isSave: true });
    // setIsOpen(false);
  };

  return (
    <Modal
      aria-labelledby="modal-title"
      aria-describedby="modal-desc"
      open={isOpen || isOpen?.isOpen}
      onClose={closeDialog}
    >
      <ModalOverflow>
        <ModalDialog minWidth={modalWidth} maxWidth={modalWidth} open={isOpen || isOpen?.isOpen}>
          <Stack rowGap={5} alignItems="center">
            <Stack rowGap={2}>
              <Typography component="h2" id="modal-title" level="title-md" textAlign="center">
                {title}
              </Typography>
              <Typography textAlign="center">{message}</Typography>
              {children}
            </Stack>
            {additionalDetails && <Stack rowGap={2}>{additionalDetails}</Stack>}
            <Stack rowGap={2} direction="row" columnGap={2}>
              <Button variant="secondary" fullWidth onClick={closeDialog}>
                {btnTextNo || "Cancel"}
              </Button>
              <Button variant="primary" fullWidth onClick={confirmation} disabled={isConfirmLoading}>
                {isConfirmLoading ? confirmLoadingText : btnTextYes || "Okay"}
              </Button>
            </Stack>
          </Stack>
        </ModalDialog>
      </ModalOverflow>
    </Modal>
  );
};

export default ConfirmModal;
